import { type Easing } from 'framer-motion';

const getFirstStepConfig = (
  difference: number,
): { y?: number | string; opacity: number; filter: string } => ({
  y: difference,
  opacity: 1,
  filter: 'drop-shadow(0px 0px 0px rgba(0,0,0,0))',
});

const easeOutTransition: {
  ease: Easing | Easing[] | undefined;
  duration: number;
} = {
  ease: 'easeOut',
  duration: 0.2,
};

export { easeOutTransition, getFirstStepConfig };
